import React from 'react';
import { PlmEventDetailForm } from './plmEvent-detail-form';

export const PlmEventAdd = () => {
  return <PlmEventDetailForm />;
};
